import React, {useEffect} from 'react'
import {CheckIcon} from '@heroicons/react/20/solid'
import {getVenueSession} from "../../requests/AppSession";
import {useNavigate} from "react-router-dom";
import {NumericFormat} from "react-number-format";
import {useAuth} from "@workos-inc/authkit-react";
import {getUserVenueReward} from "../requests/AppRequestReward";
import {SectionListSkeleton} from "./VTSkeletons";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function VTUserRewards() {
    let navigate = useNavigate();

    const {isLoading, getAccessToken} = useAuth();

    const [venueId, setVenueId] = React.useState(null);
    const [venueName, setVenueName] = React.useState(null);
    const [userReward, setUserReward] = React.useState(null);
    const [userRewardPercentBig, setUserRewardPercentBig] = React.useState('0%');
    const [userRewardPercentSmall, setUserRewardPercentSmall] = React.useState('0%');
    const [venueRewards, setVenueRewards] = React.useState([]);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const getSuccess = async responseJson => {
        if (
            responseJson &&
            responseJson.venueName
        ) {
            setVenueName(responseJson.venueName);
            setUserReward(responseJson.userReward);
            setVenueRewards(responseJson.venueRewards)

            // let percentBig = 0;
            // let percentSmall = 0;
            //
            // if(responseJson.venueRewards && responseJson.userReward){
            //     percentBig = responseJson.venueRewards[responseJson.venueRewards.length - 1].rewardGoal / responseJson.userReward.rewardPoints;
            // }
            //
            // console.log(percentBig);
            //
            // setUserRewardPercentBig(percentBig  + '%');
            // setUserRewardPercentSmall(percentSmall + '%');
        } else {
            setErrorMessage("Error getting User Venue Rewards, please refresh and verify Internet Connection.");
        }
    };

    const getError = forceLogout => {
        setErrorMessage("Error getting User Venue Rewards, please refresh and verify Internet Connection.");
    };

    useEffect(() => {
        getVenueSession().then(venueSession => {
            if (venueSession && venueSession.venueId && venueSession.venueId !== null) {
                setVenueId(venueSession.venueId);
            } else {
                navigate('/login/mobile', {replace: true});
            }

            if (!venueSession.venueRewardsFeatureFlag) {
                navigate('/login/mobile', {replace: true});
            }

        })
        return function cleanup() {

        };
    }, []);

    useEffect(() => {
        if (!isLoading && venueId !== null) {
            getUserVenueReward(venueId, getSuccess, getError, getAccessToken);
        }
        return function cleanup() {

        };
    }, [isLoading, venueId]);

    return (
        <div className="bg-white dark:bg-gray-900 py-12 px-4 sm:py-16">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <h2 className="text-base font-semibold leading-7 text-pink-600">Get Rewarded When You Buy VirtualTipz</h2>
                    {!venueName &&
                        <div className="mt-4"><SectionListSkeleton rows={3}/></div>}
                    {venueName && <p className="mt-2 text-4xl font-bold tracking-tight text-gray-900 dark:text-gray-100 sm:text-5xl">
                        {venueName} Rewards Program
                    </p>}
                </div>
                {venueName && <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600 dark:text-gray-400">
                    You get 1,000 reward points for every $100 spent buying VirtualTipz.
                </p>}
                {venueName && <div className="mt-12 text-center">
                    <h4 className="sr-only">Reward Program</h4>
                    <p className="text-xl font-medium text-gray-900 dark:text-gray-100">You currently have <span
                        className="font-bold text-2xl">
                         <NumericFormat
                             value={userReward ? userReward.rewardPoints : 0}
                             displayType={'text'}
                             decimalScale={0}
                             fixedDecimalScale={true}
                             thousandSeparator={true}
                         />
                    </span> Reward Points @ {venueName}</p>
                    <div className="mt-6" aria-hidden="true">
                        {/*<div className="hidden lg:block md:block overflow-hidden rounded-full bg-gray-200">*/}
                        {/*    <div className="h-2 rounded-full bg-pink-600" style={{ width: userRewardPercentBig }} />*/}
                        {/*</div>*/}
                        {/*<div className="lg:hidden md:hidden overflow-hidden rounded-full bg-gray-200">*/}
                        {/*    <div className="h-2 rounded-full bg-pink-600" style={{ width: userRewardPercentSmall }} />*/}
                        {/*</div>*/}
                        {/*<div className="mt-6 hidden grid-cols-4 text-sm font-medium text-gray-600 sm:grid">*/}
                        {/*    {venueRewards && venueRewards.map((venueReward, index) => (*/}
                        {/*        <div key = {venueReward.id}>*/}
                        {/*        {index == 0 ? <div key={venueReward.id}*/}
                        {/*                           className={classNames(*/}
                        {/*                               (userReward && userReward.reward && userReward.reward.id) === venueReward.id ? 'text-pink-600 font-bold' : ''*/}
                        {/*                           )}*/}
                        {/*            >{venueReward.name} ({venueReward.description})</div> :*/}
                        {/*            index + 1 == venueRewards.length ? <div key={venueReward.id} className="text-right">{venueReward.name} ({venueReward.description})</div> :*/}
                        {/*            <div key={venueReward.id} className="text-center">{venueReward.name} ({venueReward.description})</div>}*/}
                        {/*        </div>*/}
                        {/*    ))}*/}
                        {/*</div>*/}
                        {userReward && userReward.reward &&
                            <div className="mt-6 text-sm font-medium text-center text-pink-600">
                                <p>You are <span className="font-bold text-xl">{userReward.reward.name}</span> status
                                </p>
                            </div>}
                        {userReward && !userReward.reward &&
                            <div className="mt-6 text-sm font-medium text-center text-pink-600">
                                <p>No Reward Status</p>
                            </div>}
                    </div>
                </div>}
                {/*<div className="mt-16 flex justify-center">*/}
                {/*    <RadioGroup*/}
                {/*        value={frequency}*/}
                {/*        onChange={setFrequency}*/}
                {/*        className="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold leading-5 ring-1 ring-inset ring-gray-200"*/}
                {/*    >*/}
                {/*        <RadioGroup.Label className="sr-only">Payment frequency</RadioGroup.Label>*/}
                {/*        {frequencies.map((option) => (*/}
                {/*            <RadioGroup.Option*/}
                {/*                key={option.value}*/}
                {/*                value={option}*/}
                {/*                className={({ checked }) =>*/}
                {/*                    classNames(*/}
                {/*                        checked ? 'bg-pink-600 text-white' : 'text-gray-500',*/}
                {/*                        'cursor-pointer rounded-full px-2.5 py-1'*/}
                {/*                    )*/}
                {/*                }*/}
                {/*            >*/}
                {/*                <span>{option.label}</span>*/}
                {/*            </RadioGroup.Option>*/}
                {/*        ))}*/}
                {/*    </RadioGroup>*/}
                {/*</div>*/}
                <div
                    className="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 md:max-w-2xl md:grid-cols-2 lg:max-w-4xl xl:mx-0 xl:max-w-none xl:grid-cols-4">
                    {venueRewards && venueRewards.map((venueReward) => (
                        <div
                            key={venueReward.id}
                            className={classNames(
                                (userReward && userReward.reward && userReward.reward.id) === venueReward.id ? 'ring-2 ring-pink-600' : 'ring-1 ring-gray-200 dark:ring-gray-700',
                                'rounded-3xl p-8'
                            )}
                        >
                            <h3
                                className={classNames(
                                    (userReward && userReward.reward && userReward.reward.id) === venueReward.id ? 'text-pink-600' : 'text-gray-900 dark:text-gray-100',
                                    'text-lg font-semibold leading-8'
                                )}
                            >
                                {venueReward.name}
                            </h3>
                            <p className="mt-4 text-sm leading-6 text-gray-600 dark:text-gray-400">{venueReward.description}</p>
                            {/*<p className="mt-6 flex items-baseline gap-x-1">*/}
                            {/*    /!*<span className="text-4xl font-bold tracking-tight text-gray-900">{tier.price[frequency.value]}</span>*!/*/}
                            {/*    /!*<span className="text-sm font-semibold leading-6 text-gray-600">{frequency.priceSuffix}</span>*!/*/}
                            {/*</p>*/}
                            {/*<a*/}
                            {/*    href={tier.href}*/}
                            {/*    aria-describedby={tier.id}*/}
                            {/*    className={classNames(*/}
                            {/*        tier.mostPopular*/}
                            {/*            ? 'bg-pink-600 text-white shadow-sm hover:bg-pink-500'*/}
                            {/*            : 'text-pink-600 ring-1 ring-inset ring-pink-200 hover:ring-pink-300',*/}
                            {/*        'mt-6 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600'*/}
                            {/*    )}*/}
                            {/*>*/}
                            {/*    Buy plan*/}
                            {/*</a>*/}
                            <ul role="list" className="mt-8 space-y-3 text-sm leading-6 text-gray-600 dark:text-gray-400">
                                {venueReward && venueReward.features && venueReward.features.map((feature) => (
                                    <li key={feature} className="flex gap-x-3">
                                        <CheckIcon className="h-6 w-5 flex-none text-pink-600" aria-hidden="true"/>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
